import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const QrScannerError = () => {
  const navigate = useNavigate();

  // Fetch the bbpsid from localStorage
  const bbpsid = localStorage.getItem("bbpsid");

  const handleRetry = () => {
    // Navigate back to the QR scanner page with bbpsid in the URL
    navigate(`/apb-scanner?bbpsid=${encodeURIComponent(bbpsid)}`);
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#f8f9fa",
        px: 2,
      }}
    >
      <Typography
        variant="h5"
        sx={{
          mb: 2,
          fontWeight: 700,
          color: "#d32f2f",
          fontFamily: "Poppins, 'serif'",
        }}
      >
        QR Code Scanning Error
      </Typography>
      <Typography
        variant="body1"
        sx={{
          mb: 3,
          color: "#333",
          fontSize: "1.1rem",
          maxWidth: 400,
          textAlign: "center",
          fontFamily: "Poppins, 'serif'",
        }}
      >
        Oops! Something went wrong while scanning the QR code. Please make sure
        the QR code is visible and try again.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={handleRetry}
        sx={{
          px: 4,
          py: 1.5,
          fontSize: "1.1rem",
          fontWeight: 600,
          borderRadius: 3,
          boxShadow: "0 4px 16px 0 rgba(0,0,0,0.10)",
          textTransform: "none",
          background: "#003366",
          color: "white",
        }}
      >
        Try Again
      </Button>
    </Box>
  );
};

export default QrScannerError;
